import { callApi } from '@/api/apibase'

export const getUser = function () {
  return callApi('GET', `/api/external/greencourse/getUser`, null)
}
